export default __webpack_public_path__ + "static/media/bg-new.d91e0b99.jpg";